import { ORDER_FORM_ID, orderForm } from '@/features/OrderForm';
import { DEFAULT_ORDER, type OrderDto } from '@/shared/api/order';

interface GetCheckoutFormContextParams {
    orderId: string;
    signature: string;
    storeSlug: string;
    companyShopUrl: string;
    order?: OrderDto | null;
    refetch: () => Promise<unknown>;
}

export const getCheckoutFormContext = ({
    orderId,
    signature,
    storeSlug,
    companyShopUrl,
    order,
    refetch,
}: GetCheckoutFormContextParams) => {
    const form = orderForm.getInstance(ORDER_FORM_ID);
    const oldContext = form.isInitialized() && form.getContext();

    return {
        orderId,
        signature,
        storeSlug,
        storeUrl: companyShopUrl,
        order: order || DEFAULT_ORDER,
        deliveryIntervalsChunks: oldContext ? oldContext.deliveryIntervalsChunks : {},
        deliveryOptions: oldContext
            ? oldContext.deliveryOptions
            : {
                  orderDeliveryOptions: {
                      deliveryMethods: {},
                      deliveryChunksOptions: [],
                      isDeliveryChunksChanged: false,
                  },
                  isLoading: false,
              },
        paymentMethods: oldContext ? oldContext.paymentMethods : { items: [], isLoading: false },
        refetch,
    };
};
